// extracted by mini-css-extract-plugin
module.exports = {"HTEhighlight":"Wh0Gu"};